function parseFileName(fileName) {
  const lastIndex = fileName.lastIndexOf('.');
  const name = fileName.substr(0, lastIndex);
  const ext = fileName.substr(lastIndex + 1);
  return { name, ext };
};

export default parseFileName;